<template>
  <div>
    <b-card>
      <b-row>
        <b-col>
          <b-form-group label="Nombre para el rol">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="fa fa-chevron-right"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input type="text" v-model="name"></b-form-input>
            </b-input-group>
            <br>
            <b-form-textarea
              id="textarea1"
              placeholder="Descripcion"
              :rows="3"
              v-model="description"
              :max-rows="6"
            ></b-form-textarea>
          </b-form-group>
          <b-row>
            <b-col class="text-center">
              <b-form-group label="Notif. Restaurante">
                <b-form-radio-group
                  buttons
                  v-model="notif_restaurante"
                  button-variant="outline-primary"
                  size="sm"
                  :options="options"
                  name="radioBtnOutline"
                />
              </b-form-group>
            </b-col>
            <b-col class="text-center">
              <b-form-group label="Notif. Cafeteria">
                <b-form-radio-group
                  buttons
                  v-model="notif_cafeteria"
                  button-variant="outline-primary"
                  size="sm"
                  :options="options"
                  name="radioBtnOutline"
                />
              </b-form-group>
            </b-col>
            <!--<b-col>
              <b-form-group label="Notif. Papeleria">
                <b-form-radio-group
                  buttons
                  v-model="notif_papeleria"
                  button-variant="outline-primary"
                  size="sm"
                  :options="options"
                  name="radioBtnOutline"
                />
              </b-form-group>
            </b-col>-->
          </b-row>
          <b-button @click="save" class="pull-right">Guardar</b-button>
        </b-col>
        <b-col>
          <b-form-group label="Arbol de permisos">
            <b-form-checkbox-group stacked id="checkboxes2" name="flavour2" v-model="selected">
              <b-form-checkbox v-for="option in names" :key="option.id" :value="option.value">
                {{option.name}}
                <b-form-checkbox-group
                  stacked
                  id="checkboxes23"
                  name="f3lavour2"
                  v-model="selected"
                  v-if="selected.includes(option.value)"
                >
                  <b-form-checkbox
                    v-for="opt in option.children"
                    :key="opt.id"
                    :value="opt.value"
                  >{{opt.name}}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import nav from "@/_nav";

export default {
  name: "create",
  data() {
    return {
      flavours: ["Orange", "Grape", "Apple", "Lime", "Very Berry"],
      selected: [],
      allSelected: false,
      indeterminate: false,
      description: "",
      name: "",
      notif_papeleria: 0,
      notif_restaurante: 0,
      notif_cafeteria: 0,
      options: [
        {
          text: "SI",
          value: 1
        },
        {
          text: "NO",
          value: 0
        }
      ],
      names: []
    };
  },
  created() {
    this.$store.dispatch("AdminRoleData", this.$route.params).then(response => {
      if (this.$store.getters.adminRoles) {
        this.selected = JSON.parse(this.$store.getters.adminRoles.function);
        this.name = this.$store.getters.adminRoles.name;
        this.description = this.$store.getters.adminRoles.description;
        this.notif_restaurante = this.$store.getters.adminRoles.CheckRestaurante
        this.notif_cafeteria = this.$store.getters.adminRoles.CheckCafeteria
        this.notif_papeleria = 0 
      }
    });
    this.names = nav.items;
    this.names.forEach(element => {
      element.text = element.name;
      element.value = element.map_state;
      if (element.children) {
        element.children.forEach(element => {
          element.text = element.name;
          element.value = element.map_state;
        });
      }
    });
  },
  methods: {
    toggleAll(checked) {
      this.selected = checked ? this.flavours.slice() : [];
    },
    save() {
      if(!this.description){
        this.$root.showInfoDialog('Mensaje informativo','La descripcion es obligatoria','Aceptar')
        return
      }

      if(!this.name){
        this.$root.showInfoDialog('Mensaje informativo','El nombre es obligatorio','Aceptar')
        return
      }

      if(this.selected.length<1){
        this.$root.showInfoDialog('Mensaje informativo','Debe marcar por lo menos un permiso','Aceptar')
        return
      }
      
      let data = {
        id: this.$route.params.id,
        name: this.name,
        description: this.description,
        CheckRestaurante: this.notif_restaurante,
        CheckCafeteria: this.notif_cafeteria,
        function: JSON.stringify(this.selected)
      };
      this.$store
        .dispatch("AdminRoleUpdate", data)
        .then(response => {
          this.$router.push("/admin/roles/");
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/modules/admin/roles/edit.vue